import React, {useState, useEffect} from 'react'
import { GetMedia } from '../../../helpers';
import { BiCategory } from "react-icons/bi";
import Breadcrumb from '../../../components/partials/Breadcrumb';
import { Link } from 'react-router-dom';
import MUIDataTable from "mui-datatables";
const ExportMedia = () => {
  const [isLoading, setLoading] = useState(true);
  const [mediaData, setMediaData] = useState([]);

    const getData = async () => {
        let resp = await GetMedia.getAllMediaShow();
        if (resp && resp.status) {
          setMediaData(resp.data);
          setLoading(false);
        }
      }

        useEffect(() => {
          getData();
        }, [])


        const breadcrumbs = [
            { id: 1, label: "Dashboard", link: "/" },
            { id: 2, label: "Media", link: "/app/Media Library" }
          ];
          const options = {
            filter: false,
            download:true,
            print:false,
            selectableRows: false
          };
        
          const columns = [
            {
              name: 'SL'
            },
            {
              name: 'ID'
            },
            {
              name: 'Images',
              sortable: true,
              options: {
                customBodyRender: (value) => (
                  <img src={value} alt="" width={100} />
                ),
              },
            
            }
          ];
          
  return (
    <>
 
    <div className="innerPageWrapper">
      <div className="container-fluid">
        <div className="page-title">
          <h2>
            <BiCategory /> Media files
          </h2>
          <Link to="/app/media-library" className="btn btn-success">
            <BiCategory /> Media
          </Link>
        </div>
        <div className="card">
          <div className="card-body">
          <MUIDataTable
                            title="Export Media"
                            data={mediaData.map((item, i) => {

                                return [
                                    ++i,
                                    item.id,
                                    item.path,
                                  
                                ]
                            })}
                            columns={columns}
                            options={options}
                        />
          </div>
        </div>
    </div>
    </div>
     </>   
  )
}

export default ExportMedia